import Landing from 'Views/Landing';
import About from 'Views/About';
import Products from 'Views/Products';
import Contact from 'Views/Contact';
import Tasset from 'Views/Products/Tasset';
import Scryptum from 'Views/Products/Scryptum';
import Hive from 'Views/Products/Hive';
import Evo from 'Views/Products/Evo';

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Landing,
  },
  {
    path: '/home',
    name: 'Landing',
    component: Landing,
  },
  {
    path: '/about',
    name: 'About',
    component: About,
  },
  {
    path: '/products',
    name: 'Products',
    component: Products,
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
  },
  {
    path: '/products/tasset',
    name: 'Tasset',
    component: Tasset,
  },
  {
    path: '/products/scryptum',
    name: 'Scryptum',
    component: Scryptum,
  },
  {
    path: '/products/hivemecanism',
    name: 'Hive',
    component: Hive,
  },
  {
    path: '/products/evo',
    name: 'Evo',
    component: Evo,
  },
];

export default routes;
